import { Club } from '@hefe/models';
import { Descriptions, Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';

interface ClubDetailsComponentProps {
  club: Club;
}

export default function ClubDetailsComponent(props: ClubDetailsComponentProps) {
  const { club } = props;
  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item label={t('address')}>
        <Space direction="vertical" size={0}>
          <Typography.Text>{club.street}</Typography.Text>
          <Typography.Text>
            {club.zipcode} {club.city}
          </Typography.Text>
          <Typography.Text>{club.country}</Typography.Text>
        </Space>
      </Descriptions.Item>
      <Descriptions.Item label={t('email')}>
        <Typography.Text>{club.email}</Typography.Text>
      </Descriptions.Item>
      <Descriptions.Item label={t('phone')}>
        <Typography.Text>{club.phone}</Typography.Text>
      </Descriptions.Item>
    </Descriptions>
  );
}
